import { AnalyticEventNames } from '../common/analyticEventNames.enum';
import { getToken } from './api.base.service';

export const saveEvent = async (
  eventName: AnalyticEventNames,
  accountId: string | undefined,
  properties: object
): Promise<void> => {
  const data = {
    name: eventName,
    accountId,
    properties
  };
  await fetch(`${process.env.REACT_APP_REAL_GENIUS_REST}analytic-event`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: getToken()
    },
    body: JSON.stringify(data)
  });
  return;
};
